/**
 * 將 Firebase 身份驗證錯誤代碼轉換為用戶友好的錯誤訊息
 */
export const getAuthErrorMessage = (errorCode: string, language: string = 'zh-TW'): string => {
    if (errorCode.includes('IdP denied access') || errorCode.includes('user refuses to grant permission')) {
        const messages: Record<string, string> = {
            'zh-TW': '身份提供商拒絕存取。這通常發生在用戶拒絕授予權限時。',
            'en': 'Identity provider denied access. This usually happens when user refuses to grant permission.',
            'ja': 'IDプロバイダーがアクセスを拒否しました。',
        };
        return messages[language] || messages['zh-TW'];
    }

    const codeMatch = errorCode.match(/\(auth\/(.+?)\)/);
    let code = codeMatch ? `auth/${codeMatch[1]}` : errorCode;

    const zhTWMessages: Record<string, string> = {
        'auth/popup-closed-by-user': '登入視窗被關閉',
        'auth/popup-blocked': '登入視窗被瀏覽器阻擋',
        'auth/cancelled-popup-request': '登入請求已取消',
        'auth/credential-already-in-use': '此憑證已被其他用戶使用',
        'auth/email-already-in-use': '此電子郵件已被使用',
        'auth/network-request-failed': '網絡請求失敗，請檢查您的網絡連接',
        'auth/too-many-requests': '登入嘗試次數過多，請稍後再試',
        'auth/user-cancelled': '用戶取消操作',
        'auth/internal-error': '伺服器內部錯誤',
        'default': '登入失敗，請重試',
    };

    const enMessages: Record<string, string> = {
        'auth/popup-closed-by-user': 'Login popup was closed',
        'auth/popup-blocked': 'Login popup was blocked by the browser',
        'auth/cancelled-popup-request': 'Login request was cancelled',
        'auth/credential-already-in-use': 'This credential is already in use by another user',
        'auth/email-already-in-use': 'This email is already in use',
        'auth/network-request-failed': 'Network request failed, please check your connection',
        'auth/too-many-requests': 'Too many login attempts, please try again later',
        'auth/user-cancelled': 'User cancelled the operation',
        'auth/internal-error': 'Internal server error',
        'default': 'Login failed, please try again',
    };

    const jaMessages: Record<string, string> = {
        'auth/popup-closed-by-user': 'ログインポップアップが閉じられました',
        'auth/popup-blocked': 'ログインポップアップがブラウザによってブロックされました',
        'auth/cancelled-popup-request': 'ログインリクエストがキャンセルされました',
        'auth/credential-already-in-use': 'この認証情報は別のユーザーが使用しています',
        'auth/email-already-in-use': 'このメールアドレスは既に使用されています',
        'auth/network-request-failed': 'ネットワークリクエストに失敗しました',
        'auth/too-many-requests': 'ログイン試行回数が多すぎます',
        'auth/user-cancelled': 'ユーザーが操作をキャンセルしました',
        'auth/internal-error': 'サーバー内部エラー',
        'default': 'ログインに失敗しました。もう一度お試しください',
    };

    const messages =
        language === 'en' ? enMessages :
            language === 'ja' ? jaMessages : zhTWMessages;

    return messages[code] || messages['default'];
};
